// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';
// import './Navbar.css';

// function Navbar() {
//   const [showForm, setShowForm] = useState(false);
//   const toggleForm = () => setShowForm(!showForm);

//   return (
//     <>
//       <nav className="navbar">
//         {/* Left - Logo */}
//         <div className="navbar-left">
//           <img
//             src="inovaantage-logo-footer1.png"
//             alt="Company Logo"
//             className="navbar-logo"
//           />
//         </div>

//         {/* Center - Navigation Links */}
//         <ul className="nav-list">
//           <li className="dropdown">
//             <span className="dropbtn">Home</span>
//             <div className="dropdown-content">
//               <Link to="/core-value">Core Value</Link>
//               <Link to="/our-mission">Our Mission</Link>
//               <Link to="/vision">Vision</Link>
//               <Link to="/leaders">Leaders</Link>
//               <Link to="/ceo-vision">CEO Vision</Link>
//             </div>
//           </li>

//           <li className="dropdown">
//             <span className="dropbtn">About</span>
//             <div className="dropdown-content">
//               <Link to="/about/telecom">Telecom</Link>
//               <Link to="/about/utilities">Utilities</Link>
//               <Link to="/about/transportation">Transportation</Link>
//               <Link to="/about/healthcare">Healthcare</Link>
//               <Link to="/about/engineering">Engineering</Link>
//             </div>
//           </li>

//           <li className="dropdown">
//             <span className="dropbtn">Services</span>
//             <div className="dropdown-content">
//               <Link to="/services/products">Products</Link>
//             </div>
//           </li>

//           <li className="dropdown">
//             <span className="dropbtn">Gallery</span>
//             <div className="dropdown-content">
//               <Link to="/gallery/clicks">Inovaantage Clicks</Link>
//               <Link to="/gallery/videos">Inovaantage Videos</Link>
//               <Link to="/gallery/posters">Inovaantage Posters</Link>
//               <Link to="/gallery/press">Press Release</Link>
//             </div>
//           </li>

//           <li className="dropdown">
//             <span className="dropbtn">Contact</span>
//             <div className="dropdown-content">
//               <Link to="/contact/offices">Our Offices</Link>
//               <Link to="/careers">Careers</Link> 
//               <Link to="/jobopening">Job opening</Link> 
//               <Link to="/contact/Lifeatinovaantage">Life at inovaantage</Link> 



//             </div>
//           </li>
//         </ul>

//         {/* Right - Social Icons */}
//         <div className="navbar-right">
//           <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
//           <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
//           <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
//         </div>

//         {/* Contact Us Trigger */}
//         <div className="contact-link">
//           <button onClick={toggleForm}><b>Contact Us</b></button>
//         </div>
//       </nav>

//       {/* Contact Form Modal */}
//       {showForm && (
//         <div className="contact-modal">
//           <div className="contact-content">
//             <span className="close" onClick={toggleForm}>&times;</span>
//             <h2>
//               Have Questions? <br />
//               <small>Send us a Message</small>
//             </h2>
//             <form
//               className="contact-form"
//               onSubmit={(e) => {
//                 e.preventDefault();
//                 alert('Message sent successfully!');
//                 toggleForm();
//               }}
//             >
//               <input type="text" name="name" placeholder="Name" required />
//               <input type="email" name="email" placeholder="Email" required />
//               <input type="text" name="subject" placeholder="Subject" required />
//               <textarea name="message" placeholder="Message" rows="4" required></textarea>
//               <button type="submit">Send</button>
//             </form>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default Navbar;









// Navbar.jsx
// src/Components/Navbar.jsx
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';

/* -------- NAVIGATION CONFIG -------- */
const navConfig = {
  home: [
    { label: 'Core Value', to: '/core-value' },
    { label: 'Our Mission', to: '/our-mission' },
    { label: 'Vision', to: '/vision' },
    { label: 'Leaders', to: '/leaders' },
    { label: 'CEO Vision', to: '/ceo-vision' },
  ],
  about: [
    { label: 'Telecom', to: '/about/telecom' },
    { label: 'Utilities', to: '/about/utilities' },
    { label: 'Transportation', to: '/about/transportation' },
    { label: 'Healthcare', to: '/about/healthcare' },
    { label: 'Engineering', to: '/about/engineering' },
  ],
  services: [
    { label: 'Products', to: '/services/products' },
    { label: 'Carretera', to: '/contact/carretera' },
    { label: 'Inovaantage Data Migration Tool', to: '/contact/data-migration-tool' },
    { label: 'Conduit Pro', to: '/contact/conduit-pro' },
  ],
  gallery: [
    { label: 'Inovaantage Clicks', to: '/inovaantageClicks' },
    { label: 'Inovaantage Videos', to: '/gallery/videos' },
    { label: 'Inovaantage Posters', to: '/gallery/posters' },
    { label: 'Press Release', to: '/gallery/pressRelease' },
    { label: 'Inovaantage Posters', to: '/gallery/InovaantagePosters' },


  ],
  contact: [
    { label: 'Our Offices', to: '/contact/offices' },
    { label: 'Careers', to: '/careers' },
    { label: 'Job Opening', to: '/jobopening' },
    { label: 'Life at Inovaantage', to: '/contact/lifeatinovaantage' },
    ],
};

export default function Navbar() {
  /* ----- desktop dropdown state ----- */
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [activeMenu, setActiveMenu] = useState('');
  const openMenu = (e, id) => {
    setAnchorElNav(e.currentTarget);
    setActiveMenu(id);
  };
  const closeMenu = () => {
    setAnchorElNav(null);
    setActiveMenu('');
  };

  /* ----- mobile hamburger state ----- */
  const [mobileAnchor, setMobileAnchor] = useState(null);
  const openMobile = (e) => setMobileAnchor(e.currentTarget);
  const closeMobile = () => setMobileAnchor(null);

  /* ----- contact-us dialog state ----- */
  const [contactOpen, setContactOpen] = useState(false);

  const theme = useTheme();

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* ---------- TOP BAR ---------- */}
      <AppBar position="fixed" sx={{ background: '#111' }}>
        <Toolbar sx={{ px: { xs: 1, sm: 3 } }}>
          {/* Logo */}
          <Box
            component={RouterLink}
            to="/"
            sx={{ display: 'flex', alignItems: 'center', mr: 2 }}
          >
            <Box
              component="img"
              src="inovaantage-logo-footer1.png"  /* replace with imported asset if preferred */
              alt="Inovaantage"
              sx={{ height: 48 }}
            />
          </Box>

          {/* ---------- DESKTOP NAV ---------- */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {Object.keys(navConfig).map((key) => (
              <Button
                key={key}
                onClick={(e) => openMenu(e, key)}
                sx={{ my: 1, mx: 0.75, color: 'white', textTransform: 'none' }}
              >
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </Button>
            ))}
          </Box>

          {/* ---------- SOCIAL ICONS + CONTACT ---------- */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              component="a"
              href="https://www.linkedin.com/company/inovaantage"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <LinkedInIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.youtube.com/channel/UCTcGWLYt5CXlVLa0Q251QZQ"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <YouTubeIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.twitter.com/inovaantage"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <TwitterIcon />
            </IconButton>

            <Button
              variant="outlined"
              color="inherit"
              onClick={() => setContactOpen(true)}
              sx={{ ml: 2, display: { xs: 'none', sm: 'inline-flex' } }}
            >
              Contact Us
            </Button>

            {/* Hamburger for mobile */}
            <IconButton
              sx={{ display: { xs: 'flex', md: 'none' } }}
              color="inherit"
              onClick={openMobile}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Spacer to push page content below AppBar */}
      <Box sx={{ ...theme.mixins.toolbar }} />

      {/* ---------- DESKTOP DROPDOWN MENU ---------- */}
      <Menu
        anchorEl={anchorElNav}
        open={Boolean(anchorElNav)}
        onClose={closeMenu}
        keepMounted
        MenuListProps={{ sx: { minWidth: 200 } }}
      >
        {activeMenu &&
          navConfig[activeMenu].map((item) => (
            <MenuItem
              key={item.to}
              component={RouterLink}
              to={item.to}
              onClick={closeMenu}
            >
              {item.label}
            </MenuItem>
          ))}
      </Menu>

      {/* ---------- MOBILE MENU (HAMBURGER) ---------- */}
      <Menu
        anchorEl={mobileAnchor}
        open={Boolean(mobileAnchor)}
        onClose={closeMobile}
        keepMounted
        PaperProps={{ sx: { width: '80vw', maxWidth: 280 } }}
      >
        {Object.values(navConfig)
          .flat()
          .map((item) => (
            <MenuItem
              key={item.to}
              component={RouterLink}
              to={item.to}
              onClick={closeMobile}
            >
              {item.label}
            </MenuItem>
          ))}
        <MenuItem divider />
        <MenuItem
          onClick={() => {
            closeMobile();
            setContactOpen(true);
          }}
        >
          Contact Us
        </MenuItem>
      </Menu>

      {/* ---------- CONTACT-US DIALOG ---------- */}
      <Dialog open={contactOpen} onClose={() => setContactOpen(false)}>
        <DialogTitle>
          Have Questions?{' '}
          <Typography variant="subtitle2" component="span">
            Send us a message
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Box component="form" id="contact-form" sx={{ mt: 1 }}>
            <TextField margin="dense" label="Name" fullWidth required />
            <TextField margin="dense" label="Email" type="email" fullWidth required />
            <TextField margin="dense" label="Subject" fullWidth required />
            <TextField
              margin="dense"
              label="Message"
              fullWidth
              multiline
              rows={4}
              required
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setContactOpen(false)}>Cancel</Button>
          <Button
            form="contact-form"
            type="submit"
            variant="contained"
            onClick={() => {
              setContactOpen(false);
              alert('Message sent successfully!');
            }}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
